<template>
  <Can action="view" subject="payment">
    <div data-component-group="payment-dialog" data-component="edit">
      <dialog-edit
        :title="`${$t('payment')} ${activePayment.id}`"
        icon="payment"
        :to="`/payments/${activePayment?.id}`"
        content-class="edit-payment-dialog"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-payment-edit
            :payment="activePayment"
            :is-loading="isEditingPayment"
            :on-cancel="onCancel"
            :on-submit="$ability.can('update', 'payment') ? updatePayment : undefined"
          />
        </template>
      </dialog-edit>
    </div>
  </Can>
</template>

<script>
  export default {
    emits: ['saved'],
    data() {
      return {
        isEditingPayment: false,
      };
    },
    created() {
      if (!this.activePayment?.id) {
        this.$store.dispatch('payments/getItem', { id: this.$route.params.id });
      }
    },
    computed: {
      activePayment() {
        return this.$store.getters['payments/activeItem'];
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'payments', query: this.$route.query });
      },
      updatePayment({ discount }) {
        const { id, amount } = this.activePayment;

        if (discount === amount.discount) {
          return Promise.resolve();
        }

        const query = { id, discount };

        this.isEditingPayment = true;

        return this.$store
          .dispatch('payments/update', query)
          .then((res) => {
            this.$emit('saved');
            this.$router.push({ name: 'payments', query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isEditingPayment = false;
          });
      },
    },
  };
</script>
